import React from "react";

import { useFlags } from "launchdarkly-react-client-sdk";
import { useParams } from "react-router-dom";

import { ClientId } from "@fartherfinance/frontend/api/Types";

import RedirectWithFlag from "@src/config/routing/RedirectWithFlag";
import { InvestmentsPath } from "@src/config/routing/RouterPaths";
import TabPanel from "@src/multiCustodian/components/Advisor/Investments/SharedComponents/TabPanel/TabPanel";
import TransitionProposals from "@src/multiCustodian/components/TransitionProposals/TransitionProposals";

import styles from "./TransitionProposalsTab.module.css";

const TransitionProposalsTab = (): JSX.Element => {
  const { clientId } = useParams<{
    clientId: ClientId;
  }>();

  const { enableTransitionProposals } = useFlags();

  return (
    <RedirectWithFlag
      flag={enableTransitionProposals}
      redirectPath={`/Client/${clientId}/${InvestmentsPath}`}
    >
      <TabPanel
        className={styles.tabPanel}
        value={`/Client/${clientId}/${InvestmentsPath}/TransitionProposals`}
      >
        <TransitionProposals />
      </TabPanel>
    </RedirectWithFlag>
  );
};

export default TransitionProposalsTab;
